import { render, staticRenderFns } from "./znpc.vue?vue&type=template&id=4f75061f&scoped=true&"
import script from "./znpc.vue?vue&type=script&lang=js&"
export * from "./znpc.vue?vue&type=script&lang=js&"
import style0 from "./znpc.vue?vue&type=style&index=0&id=4f75061f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f75061f",
  null
  
)

export default component.exports